import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=0a4a1054"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"
import style0 from "./UserView.vue?vue&type=style&index=0&id=0a4a1054&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports